module.exports = __webpack_public_path__ + "static/media/hotel1.2616a187.jpeg";